export const PAGINATION_PAGE_NUMBER = 2
export const DEFAULT_PAGE = '1'
export const DEFAULT_PAGE_SIZE = '10'
export const PAGE_SIZE_MAX = '200'

export const STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
} as const

export const ALLOWED_UPLOAD_FILE_TYPES = ['text/csv']

export const FORMAT_DATE = {
  DATE_TIME: 'MM/DD/YYYY hh:mm A',
  TIME_12: 'hh:mm A',
  DATE_TIME_24H: 'MM/DD/YYYY HH:mm',
  DATE_TIME_FULL: 'MM/DD/YYYY hh:mm:ss A',
  DATE: 'MM/DD/YYYY',
  DATE_TIME_TIMEZONE_FULL: 'MM/DD/YYYY hh:mm:ss A Z',
  DATE_TIME_TIMEZONE_EXCLUDE_SECOND: 'MM/DD/YYYY hh:mm A Z',
  TIMEZONE: 'Z',
}

export const VALID_COLOR = '#50cd89'
export const INVALID_COLOR = '#f1416c'
export const DEFAULT_COLOR = '#e4e6ef'

export const TABLE_KEY_COLUMN = {
  CAN_CHECK: 'canCheck',
  ACTIONS: 'actions',
  SUB_ACTIONS: 'sub-actions',
}
